module.exports = __webpack_public_path__ + "worldexpo-2.jpg?73897d86515d2ccaf7de8c2d7d7f2870";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/worldexpo-2.jpg
// module id = 276
// module chunks = 0